import { render, staticRenderFns } from "./barcode-information.vue?vue&type=template&id=6eb21f42&scoped=true"
import script from "./barcode-information.vue?vue&type=script&lang=js"
export * from "./barcode-information.vue?vue&type=script&lang=js"
import style0 from "./barcode-information.vue?vue&type=style&index=0&id=6eb21f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb21f42",
  null
  
)

export default component.exports